import api from '../Utils/api';

export interface SizeChartMeasurement {
    type: string;
    value: string;
}

export interface SizeChart {
    chart_type: string;
    fit: string;
    garment_id: string;
    gender: 'mens' | 'womens';
    sizes: Record<string, SizeChartMeasurement[]>;
    sizing_system: string;
    style: string;
    tags: string[];
    unit: 'cm' | 'in';
}

export interface SizeChartMappingResponse {
    size_charts: SizeChart[];
}

const sizingService = {
    getSizeChartMapping: async ({
        partnerId,
        brand,
        garment_category,
    }: {
        partnerId: string;
        brand: string;
        garment_category: string;
    }): Promise<SizeChartMappingResponse> => {
        const queryParams = new URLSearchParams({
            partner_id: partnerId,
            brand,
            garment_category,
        });
        return api.get(`/v1/size-chart-mapping?${queryParams.toString()}`);
    },
    getSizeCharts: async ({
        garmentId,
    }: {
        garmentId: string;
    }): Promise<{ size_chart_id: string }> => {
        return api.get(`/v1/ingestion/size-chart/garment/${garmentId}`);
    },
};

export default sizingService;
